import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import TextInput from '../common/components/formInputs/TextInput'
import SelectInput from '../common/components/formInputs/SelectInput'
import TextareaInput from '../common/components/formInputs/TextareaInput'
import ImageInput from '../common/components/formInputs/ImageInput'

const FirstStep = ({
  displayStep,
  buildingOptions,
  eventTypeOptions,
  trainerOptions,
  formValues,
  setFieldValue,
}) => {
  const { t } = useTranslation(['eventManagement'])
  const selectedBuilding = useSelector(selectActiveBuilding)
  const selectedBuildingId = selectedBuilding ? selectedBuilding.id : null

  useEffect(() => {
    if (formValues.building) {
      return
    }

    const defaultBuilding = buildingOptions.find((option) => option.id === selectedBuildingId)

    if (!defaultBuilding) {
      return
    }

    setFieldValue('building', defaultBuilding)
  }, [selectedBuildingId, formValues, buildingOptions])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <div className="columns">
        <SelectInput
          columnSize={6}
          name="building"
          label={t('eventManagement:classFormPage.firstStep.buildingLabel')}
          options={buildingOptions}
          value={formValues.building}
          setFieldValue={setFieldValue}
        />
        <SelectInput
          columnSize={6}
          name="type"
          label={t('eventManagement:classFormPage.firstStep.typeLabel')}
          placeholder={t('eventManagement:classFormPage.firstStep.typePlaceholder')}
          options={eventTypeOptions}
          value={formValues.type}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <TextInput
          columnSize={6}
          name="name"
          label={t('eventManagement:classFormPage.firstStep.nameLabel')}
          placeholder={t('eventManagement:classFormPage.firstStep.namePlaceholder')}
          value={formValues.name}
          setFieldValue={setFieldValue}
        />
        <SelectInput
          columnSize={6}
          name="organizer"
          label={t('eventManagement:classFormPage.firstStep.trainerLabel')}
          placeholder={t('eventManagement:classFormPage.firstStep.trainerPlaceholder')}
          options={trainerOptions}
          value={formValues.organizer}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <TextareaInput
          columnSize={12}
          name="description"
          label={t('eventManagement:classFormPage.firstStep.descriptionLabel')}
          placeholder={t('eventManagement:classFormPage.firstStep.descriptionPlaceholder')}
          value={formValues.description}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <ImageInput
          columnSize={12}
          name="image"
          value={formValues.image}
          eventName={formValues.name}
          eventType="Class"
          setFieldValue={setFieldValue}
        />
      </div>
    </React.Fragment>
  )
}

FirstStep.propTypes = {
  displayStep: PropTypes.bool,
  buildingOptions: PropTypes.array,
  eventTypeOptions: PropTypes.array,
  trainerOptions: PropTypes.array,
  selectedBuildingId: PropTypes.number,
  formValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default FirstStep
